import React from 'react'
import gif from '../images/loading.gif'


export default () => (
  <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%' }}>
    <img height="300" src={gif} alt="Loading!"/>
  </div>
)
